<template>
  <div class="forum" id="forum">
    <div class="header" :style="{backgroundColor:isComing?'#ff3c00':'#fff'}">
      <img src="https://summit-img.geekpark.net/mobile/%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E9%BB%91%E8%89%B2.png"
           v-show="!isComing">
      <img src="https://summit-img.geekpark.net/mobile/%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-mobile-%E7%99%BD.svg"
           v-show="isComing">
    </div>
    <div class="content">
      <a href="https://techday.geekpark.net" target="_blank">
        <img src="https://summit-img.geekpark.net/techday/TECHDAY-%E5%85%A5%E5%8F%A3-m.png" alt="" style="width: 100%">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Forum',
  data () {
    return {
      isComing: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    getElementTop (element) {
      let actualTop = element.offsetTop
      let current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }

      return actualTop
    },
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scheduleTop = this.getElementTop(document.querySelector('#forum'))
      if (scrollHeight > scheduleTop - 400) {
        this.isComing = true
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .header {
    box-sizing: border-box;
    width: 90vw;
    margin: auto;
    padding: 8vw 0;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    transition: background-color .7s;

    img {
      width: 76vw;
    }
  }

  .content{
    width: 90vw;
    margin: 7vw  auto 14vw auto;
  }
</style>
